import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EnvironmentService } from './EnvironmentService';
import { Job, JobService } from './JobService';
import { User, wooId } from './shared-types';

@Injectable({ providedIn: 'root' })
export class RevenueReportsService {
  constructor(private http: HttpClient, private env: EnvironmentService, private jobService: JobService) {}

  downloadAgressoXlsx(id: wooId): Promise<Blob> {
    return lastValueFrom(
      this.http.get(`${this.env.apiUrl}/revenue_reports/${id}/agresso_xlsx`, {
        responseType: 'blob',
      }),
    );
  }

  downloadAgressoXml(id: wooId): Promise<Blob> {
    return lastValueFrom(
      this.http.get(`${this.env.apiUrl}/revenue_reports/${id}/agresso_xml`, {
        responseType: 'blob',
      }),
    );
  }

  downloadTeliaXlsx(id: wooId): Promise<Blob> {
    return lastValueFrom(
      this.http.get(`${this.env.apiUrl}/revenue_reports/${id}/telia_xlsx`, {
        responseType: 'blob',
      }),
    );
  }

  downloadTeliaXml(id: wooId): Promise<Blob> {
    return lastValueFrom(
      this.http.get(`${this.env.apiUrl}/revenue_reports/${id}/telia_xml`, {
        responseType: 'blob',
      }),
    );
  }

  downloadErpXlsx(id: wooId): Promise<Blob> {
    return lastValueFrom(
      this.http.get(`${this.env.apiUrl}/revenue_reports/${id}/erp_xlsx`, {
        responseType: 'blob',
      }),
    );
  }

  downloadErpXml(id: wooId): Promise<Blob> {
    return lastValueFrom(
      this.http.get(`${this.env.apiUrl}/revenue_reports/${id}/erp_xml`, {
        responseType: 'blob',
      }),
    );
  }

  async sendToErp(id: wooId): Promise<any> {
    return this.jobService.waitForJobCompletion(
      (await lastValueFrom(this.http.patch<Job>(`${this.env.apiUrl}/revenue_reports/${id}/send_to_erp`, null))).id,
    );
  }

  getAll(): Promise<RevenueReport[]> {
    return lastValueFrom(this.http.get<RevenueReport[]>(`${this.env.apiUrl}/revenue_reports`));
  }

  get(id: wooId): Promise<RevenueReport> {
    return lastValueFrom(this.http.get<RevenueReport>(`${this.env.apiUrl}/revenue_reports/${id}`));
  }

  async sendToTelia(id: wooId): Promise<any> {
    return this.jobService.waitForJobCompletion(
      (await lastValueFrom(this.http.patch<Job>(`${this.env.apiUrl}/revenue_reports/${id}/send_to_telia`, null))).id,
    );
  }
}

export interface RevenueReport {
  id: wooId;
  year: number;
  month: number;
  has_agresso_files: boolean;
  sent_to_agresso_at: string;
  sent_to_agresso_by: Pick<User, 'id' | 'first_name' | 'last_name'>;
  has_telia_files: boolean;
  sent_to_telia_at: string;
  sent_to_telia_by: Pick<User, 'id' | 'first_name' | 'last_name'>;
  has_erp_files: boolean;
  sent_to_erp_at: string;
  sent_to_erp_by: Pick<User, 'id' | 'first_name' | 'last_name'>;
}
